<template>
  <generic-modal
    size
    :title="$t('movements')"
    icon="receipt"
    image="/images/icons/receipt.png"
    v-on:destroy="destroy"
    :on_finished="finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("account finder") }}</label>
            <div class="ui blue search" ref="account_search">
              <div class="ui icon input">
                <input
                  class="prompt"
                  type="text"
                  name="account"
                  v-model="account.number"
                  :placeholder="$t('search account')"
                />
                <i class="search icon"></i>
              </div>
              <div class="results"></div>
            </div>
            <div class="field" style="margin-top: 15px">
              <label for>{{ $t("movement type") }}</label>
              <div class="ui search selection dropdown" ref="types_dropdown">
                <input type="hidden" name="type" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu"></div>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="ui horizontal cards" v-if="account">
              <div class="card">
                <div class="image">
                  <img src="/images/icons/matthew.png" />
                </div>
                <div class="content">
                  <div class="header">{{ account.name }}</div>
                  <div class="meta">
                    <a>{{ account.number }}</a>
                  </div>
                  <div class="description">
                    <!-- <pre>{{ student }}</pre> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ui container" v-if="movements && movements.length">
          <h4 class="ui dividing header">{{ $t("new movements") }}</h4>
          <div class="ui list">
            <div
              class="item"
              v-for="(movement, index) in movements"
              :key="index"
            >
              <i class="red trash icon" @click="remove(movement, index)"></i>
              <div class="content">
                <div class="three fields">
                  <div class="field">
                    <label for="">{{ movement.name }}</label>
                    <div class="ui labeled input">
                      <label for="amount" class="ui label">Q</label>
                      <input type="text" v-model="movements[index].amount" />
                      <!-- <div class="ui basic label">.00</div> -->
                    </div>
                  </div>
                  <div class="field" v-if="movement.expire_date">
                    <label for="">{{ $t("expire date") }}</label>
                    <!-- <input type="text" v-model="movements[index].expire_date" /> -->
                    <div class="ui calendar" ref="expire_calendar">
                      <div class="ui input left icon">
                        <i class="calendar icon"></i>
                        <input
                          type="text"
                          :placeholder="$t('expire date')"
                          v-model="movements[index].expire_date"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="field">
                    <label for="">{{ $t("options") }}</label>
                    <div
                      class="ui red basic icon button"
                      @click="remove(movement, index)"
                    >
                      <i class="trash icon"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ui message error"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, stringify, init_search } from "@/utils";
import GenericModal from "@/components/GenericModal";
import filters from "@/filters";
import moment from "moment";
import { v4 } from "uuid";

export default {
  name: "MovementModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
  },
  props: {
    account_in: Object,
  },
  computed: {},
  data() {
    return {
      account: {},
      movement_types: [],
      movements: [],
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      window.jQuery(this.$refs.form).form("validate form");
      let isValid = window.jQuery(this.$refs.form).form("is valid");
      let vm = this;
      return new Promise((resolve, reject) => {
        if (isValid) {
          local_api(vm, "post", "/collegiate_account_movement/do-create", {
            a: vm.account.uuid,
            c: vm.movements,
          })
            .then((response) => {
              vm.$emit("succedded", response);
              resolve(response);
            })
            .catch((err) => {
              window.jQuery(this.$refs.form).form("add errors", [err]);
              reject(err);
            });
        } else {
          reject();
        }
      });
    },
    remove(movement, index) {
      this.movements.splice(index, 1);
    },
  },
  created() {
    let vm = this;
    if (vm.account_in) vm.account = vm.account_in;

    local_api(vm, "post", "/collegiate_account_movement_type/do-get-list", {})
      .then((types) => {
        vm.movement_types = types.map((t) => {
          t.setup = JSON.parse(t.setup);
          return t;
        });

        let dd = window
          .jQuery(vm.$refs.types_dropdown)
          .dropdown("setup menu", {
            values: vm.movement_types.map((p) => {
              return {
                name: p.name,
                value: p.type_id,
              };
            }),
          })
          .dropdown({
            onChange(value) {
              if (value) {
                let trgt = vm.movement_types.find((t) => t.type_id == value);
                let amount = 0;
                let expire_date = "";
                if (trgt) {
                  if (trgt.setup && trgt.setup.default_amount)
                    amount = trgt.setup.default_amount;
                  if (trgt.setup && trgt.setup.arrear)
                    if (trgt.setup.arrear.policy == "s") {
                      // Specific day of month
                      let day = trgt.setup.arrear.specific_day;
                      let currentDate = new Date();
                      let currentDay = currentDate.getDate();
                      if (day < currentDay)
                        expire_date = new Date(
                          currentDate.getFullYear(),
                          currentDate.getMonth() + 1,
                          day
                        );
                      else
                        expire_date = new Date(
                          currentDate.getFullYear(),
                          currentDate.getMonth(),
                          day
                        );
                    } else if (trgt.setup.arrear.policy == "g") {
                      // Grace days
                      let currDte = moment();
                      expire_date = currDte.add(
                        trgt.setup.arrear.grace_days,
                        "d"
                      );
                    } else if (trgt.setup.arrear.policy == "n") {
                      // None
                      expire_date = null;
                    }

                  vm.movements.push({
                    type_id: trgt.type_id,
                    name: trgt.name,
                    amount: amount,
                    expire_date: expire_date,
                    uuid: v4(),
                  });

                  setTimeout(() => {
                    dd.dropdown("clear", true);

                    window.jQuery(vm.$refs.expire_calendar).calendar({
                      type: "date",
                    });

                    // window
                    //   .jQuery(vm.$refs.period_dropdown)
                    //   .dropdown("setup menu", {
                    //     values: vm.periods.map((p) => {
                    //       return {
                    //         name: p.name,
                    //         value: p.period_id,
                    //       };
                    //     }),
                    //   })
                    //   .dropdown({
                    //     onChange(value) {
                    //       let uuid = window.jQuery(this).data("i");
                    //       let trgt = vm.movements.find((el) => el.uuid == uuid);
                    //       if (trgt) {
                    //         trgt.period_id = value;
                    //       }
                    //     },
                    //   });
                    // .dropdown(
                    //   "set selected",
                    //   vm.periods.find((p) => {
                    //     return p.is_active;
                    //   }).period_id,
                    // );
                  }, 200);
                }
              }
            },
          });
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });

    // local_api(vm, "post", "/student_configuration/do-get-configuration", {})
    //   .then((conf) => {
    //     if (conf) {
    //       vm.periods = conf.std_periods;
    //     }
    //   })
    //   .catch((err) => {
    //     vm.$alertify.error(stringify(err));
    //   });
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {},
    });

    let onSearchResponse = (data) => {
      let rslt = [];
      data.map((r) => {
        rslt.push({
          title: r.name,
          description: r.number,
          account: r,
        });
      });
      return { results: rslt };
    };
    let onSearchSelect = (data) => {
      vm.account = data.account;
    };

    init_search(
      vm,
      this.$refs.account_search,
      "search account",
      onSearchResponse,
      onSearchSelect
    );
  },
  watch: {},
};
</script>
